import {
  InputLabel,
  TableBody,
  TextField,
  Typography,
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import ButtonController from "components/request-document/components/ButtonController";
import {
  Bagde,
  StyledTableCell,
  useStyles,
} from "components/request-document/components/Commons";
import usePersonalDetail from "components/request-document/hooks/usePersonalDetail";
import useSmartForm from "components/request-document/hooks/useSmartForm";
import useSmartService from "components/request-document/hooks/useSmartService";
import { useFormik } from "formik";
import { REQUEST_DOCUMENT_STEP } from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { getErrorMessage } from "libs/utils/form";
import { get, isError } from "lodash-es";
import { React, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartForm,
  addSmartFormSlice,
  getSmartFormFieldConfig,
  selectCurrentSmartForm,
  selectSmartFormFieldConfig,
} from "redux/modules/visaForm";
import * as yup from "yup";

export default function UserProfileStepC() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);
  const canEdit = useSelector(canEditForm);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const smartform = useSelector(selectCurrentSmartForm);

  const { smartserviceId } = useSmartService();
  const { personalId } = usePersonalDetail();
  const { draftId, addSmartFormState, getSmartForm } = useSmartForm();

  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });

  const detailList = [
    "OrganiztionName",
    "RefernceName",
    "ReferncePosition",
    "OrganiztionPhone",
    "RefernceEmail",
  ];
  const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
  const partfromId =
    defaultType.find((field) => field.partFromName === "Part C")?.partfromId ||
    "";
  const detail = get(smartform, "detail", [])
    .filter((field) => field.partfromId === partfromId)
    .filter((field) => detailList.includes(field.smartName))
    .reduce(smartNameById, {});

  useEffect(() => {
    if (smartserviceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId }));
      getSmartForm({
        smartserviceId,
        draftId,
        personalId,
      });
    }
  }, [dispatch, draftId, getSmartForm, personalId, smartserviceId]);

  useEffect(() => {
    if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
        if (!isSaveDraft) {
          dispatch(setSmartFormStep(SMART_T_STEP.PART_E));
        } else {
          getSmartForm({
            smartserviceId,
            draftId,
            personalId,
          });
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [
    addSmartFormState.error?.message,
    addSmartFormState.isFailure,
    addSmartFormState.isLoading,
    addSmartFormState.isSuccess,
    dispatch,
    draftId,
    getSmartForm,
    hideLoading,
    isSaveDraft,
    personalId,
    smartserviceId,
  ]);

  const callAPISubmit = async (values) => {
    showLoading();
    const { visaissuance, ...restValues } = values;
    const documentFields = Object.keys(restValues);
    const getFieldListConfig = defaultType
      .filter((field) => field.partfromId === partfromId)
      .filter((field) => documentFields.includes(field.smartName));

    const getValue = (field) => {
      switch (field.smartName) {
        default:
          return get(values, `${field.smartName}`, null);
      }
    };

    const getSmartId = (field) =>
      get(detail, `${field.smartName}.smartId`, null);

    const prepareData = {
      draftId: draftId || null,
      smartserviceId,
      personalId: personalId,
      survey: null,
      visaissuance: visaissuance,
      detail: getFieldListConfig.map((field) => ({
        smartName: field.smartName,
        smartId: getSmartId(field),
        partfromId: field.partfromId,
        configsmartId: field.configsmartId,
        linkTable: field.linkTable,
        value: getValue(field),
      })),
    };

    await dispatch(
      addSmartForm({
        data: prepareData,
      })
    );
  };

  const validationSchema = yup.object({});
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      OrganiztionName: get(detail, "OrganiztionName.value", ""),
      RefernceName: get(detail, "RefernceName.value", ""),
      ReferncePosition: get(detail, "ReferncePosition.value", ""),
      OrganiztionPhone: get(detail, "OrganiztionPhone.value", ""),
      RefernceEmail: get(detail, "RefernceEmail.value", ""),
    },
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  return (
    <div className={classes.root}>
      <form onSubmit={formik.handleSubmit}>
        <ContentTitle
          title="Application Form"
          subTitle="APPLICATION FOR QUALIFICATION ENDORSEMENT FOR SMART VISA “S”"
        />
        <Steper currentStep={1} stepInfo={REQUEST_DOCUMENT_STEP} />
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={4}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Part C : Government institute from which you received
                    endorsement
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={1} />
                    <div className={classes.wrapField}>
                      <InputLabel>Organization name</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="OrganiztionName"
                        value={formik.values.OrganiztionName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("OrganiztionName", formik)}
                        helperText={getErrorMessage("OrganiztionName", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={2} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Name of reference person or contact person at the
                        program
                      </InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="RefernceName"
                        value={formik.values.RefernceName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("RefernceName", formik)}
                        helperText={getErrorMessage("RefernceName", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRow>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={3} />
                    <div className={classes.wrapField}>
                      <InputLabel>Position</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="ReferncePosition"
                        value={formik.values.ReferncePosition}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("ReferncePosition", formik)}
                        helperText={getErrorMessage("ReferncePosition", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={4} />
                    <div className={classes.wrapField}>
                      <InputLabel>Mobile phone number</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        type="number"
                        variant="outlined"
                        className={classes.textField}
                        name="OrganiztionPhone"
                        value={formik.values.OrganiztionPhone}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("OrganiztionPhone", formik)}
                        helperText={getErrorMessage("OrganiztionPhone", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.cellContent}>
                    <Bagde number={5} />
                    <div className={classes.wrapField}>
                      <InputLabel>E-mail address</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="RefernceEmail"
                        value={formik.values.RefernceEmail}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("RefernceEmail", formik)}
                        helperText={getErrorMessage("RefernceEmail", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <ButtonController
          onClickSaveDraft={() => {
            if (!canEdit) {
              dispatch(setSmartFormStep(SMART_T_STEP.PART_E));
              return;
            }
            setSaveDraft(true);
            callAPISubmit(formik.values);
          }}
        />
      </form>
    </div>
  );
}
